import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { 
  ChevronRight, 
  ShoppingCart, 
  Check, 
  Leaf, 
  Thermometer, 
  Droplet, 
  Coffee,
  ChevronDown,
  ChevronUp,
  Package,
  Award,
  Clock,
  Gift,
  X,
  ChevronLeft,
  ZoomIn,
  Truck,
  AlertCircle
} from 'lucide-react';
import cup220_1 from '../assets/cup/c1.jpg';
//import cup220_1 from '../assets/images/cup220_1.jpg';
import cup220_2 from '../assets/cup/c9.jpg';
import cup220_3 from '../assets/images/cup220_3.jpg';
import cup220_4 from '../assets/images/cup220_4.jpg';
import cup220_description from '../assets/images/cup220_description.jpg';
import cup220_ingredients from '../assets/images/cup220_ingredients.jpg';
import cup220_cupffee from '../assets/cup/c2.jpg';
import { useCart } from '../context/CartContext';
import { getPriceInfo, isDiscountActive, getDiscountPercentage } from '../config/discountConfig';
import { getProductStock, STOCK_STATUS } from '../config/productConfig';
import RelatedProducts from '../components/RelatedProducts';

const EdibleCup220 = () => {
  const [selectedQuantity, setSelectedQuantity] = useState('12');
  const [activeTab, setActiveTab] = useState('description');
  const [selectedImage, setSelectedImage] = useState(0);
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [isQuantityDropdownOpen, setIsQuantityDropdownOpen] = useState(false);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [lightboxImageIndex, setLightboxImageIndex] = useState(0);
  const [isAddedToCart, setIsAddedToCart] = useState(false);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const productImageRef = useRef(null);
  
  const { addToCartWithAnimation } = useCart();
  
  // Get stock status from config
  const stockInfo = getProductStock('edible-cup-220');

// Carton pricing options (12 cups per carton) with .99 pricing for all quantities
const pricingOptions = [
  { cups: 'sample', cartons: 0, price: 0, label: 'Sample', description: 'Free sample' },
  { cups: 12, cartons: 1, price: 12.99, label: '12 cups', description: '1 carton' },
  { cups: 24, cartons: 2, price: 24.99, label: '24 cups', description: '2 cartons' },
  { cups: 36, cartons: 3, price: 35.99, label: '36 cups', description: '3 cartons' },
  { cups: 48, cartons: 4, price: 45.99, label: '48 cups', description: '4 cartons' },
  { cups: 60, cartons: 5, price: 55.99, label: '60 cups', description: '5 cartons' },
  { cups: 72, cartons: 6, price: 65.99, label: '72 cups', description: '6 cartons' },
  { cups: 84, cartons: 7, price: 73.99, label: '84 cups', description: '7 cartons' },
  { cups: 96, cartons: 8, price: 81.99, label: '96 cups', description: '8 cartons' },
  { cups: 108, cartons: 9, price: 89.99, label: '108 cups', description: '9 cartons' },
  { cups: 120, cartons: 10, price: 97.99, label: '120 cups', description: '10 cartons' },
  { cups: 132, cartons: 11, price: 107.99, label: '132 cups', description: '11 cartons' },
  { cups: 144, cartons: 12, price: 117.99, label: '144 cups', description: '12 cartons' },
  { cups: 156, cartons: 13, price: 127.99, label: '156 cups', description: '13 cartons' },
  { cups: 168, cartons: 14, price: 137.99, label: '168 cups', description: '14 cartons' },
  { cups: 180, cartons: 15, price: 147.99, label: '180 cups', description: '15 cartons' },
  { cups: 192, cartons: 16, price: 157.99, label: '192 cups', description: '16 cartons' },
  { cups: 204, cartons: 17, price: 167.99, label: '204 cups', description: '17 cartons' },
  { cups: 216, cartons: 18, price: 177.99, label: '216 cups', description: '18 cartons' },
  { cups: 228, cartons: 19, price: 187.99, label: '228 cups', description: '19 cartons' },
  { cups: 240, cartons: 20, price: 197.99, label: '240 cups', description: '20 cartons' }
];

  const getSelectedPricing = () => {
    return pricingOptions.find(opt => String(opt.cups) === selectedQuantity) || pricingOptions[1];
  };

  const selectedPricing = getSelectedPricing();

  // Product images gallery - 220ml specific (new images)
  const productImages = [
    { 
      id: 0, 
      src: cup220_cupffee, 
      alt: "Edible CUP 220ml - Product Showcase" 
    },
	{ 
      id: 1, 
      src: cup220_1, 
      alt: "Edible CUP 220ml - Main Product View" 
    },
    { 
      id: 2, 
      src: cup220_2, 
      alt: "Edible CUP 220ml - Product Showcase" 
    },
    { 
      id: 3, 
      src: cup220_3, 
      alt: "Edible CUP 220ml - Product Display" 
    },
    { 
      id: 4, 
      src: cup220_4, 
      alt: "Edible CUP 220ml - In Use" 
    },
    { 
      id: 5, 
      src: cup220_description, 
      alt: "Edible CUP 220ml - Product Description" 
    },
    { 
      id: 6, 
      src: cup220_ingredients, 
      alt: "Edible CUP 220ml - Ingredients" 
    },
  ];

  // Handle keyboard navigation in lightbox
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isLightboxOpen) return;
      
      if (e.key === 'Escape') {
        setIsLightboxOpen(false);
      } else if (e.key === 'ArrowRight') {
        setLightboxImageIndex((prev) => (prev + 1) % productImages.length);
      } else if (e.key === 'ArrowLeft') {
        setLightboxImageIndex((prev) => (prev - 1 + productImages.length) % productImages.length);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isLightboxOpen]);

  // Prevent body scroll when lightbox is open
  useEffect(() => {
    if (isLightboxOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isLightboxOpen]);

  const openLightbox = (index) => {
    setLightboxImageIndex(index);
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => {
    setIsLightboxOpen(false);
  };

  const goToNextImage = () => {
    setLightboxImageIndex((prev) => (prev + 1) % productImages.length);
  };

  const goToPrevImage = () => {
    setLightboxImageIndex((prev) => (prev - 1 + productImages.length) % productImages.length);
  };

  // 220ml Product specific details
  const product = {
    name: "Edible CUP | 220 ml",
    subtitle: "The Perfect Standard Size for coffee, tea & Ice Cream",
    sku: "CUP-220-STD",
    cupsPerCarton: 12
  };

  // Key features specific to 220ml
  const keyFeatures = [
    "220ml capacity - ideal for standard coffee, tea & Ice Cream",
    "Sold in cartons of 12 cups",
    "100% Edible & Vegan",
    "Heat resistant up to 85°C",
    "Leak-proof for 40+ minutes",
    "GMO-free natural ingredients"
  ];

  // Product details specific to 220ml
  const productDetails = {
    dimensions: {
      height: "8 cm",
      topDiameter: "7.8cm",
      bottomDiameter: "5.5 cm",
      weight: "26g",
      capacity: "220 ml"
    },
    ingredients: [
      "Wheat flour",
      "Oat bran",
      "Sugar",
      "Refined cocnout oil",
      "Stabilizers",
      "Sodium alginate (E401)",
      "Xanthan gum (E415)",
	  "Enzyme PreventASe"
    ],
    nutritionalInfo: {
      calories: "105 kcal",
      protein: "3.4g",
      carbohydrates: "20.3g",
      fat: "1.1g",
      Sugars: "3.4g"
    },
    storage: "Store in a cool, dry place (15-25°C) away from direct sunlight. Keep in original packaging until use. Best consumed within 12 months of production date. Once opened, use within 5 days.",
    certifications: ["FSSC 22000", "Vegan Certified", "Halal Certified", "FDA Approved"],
    shelfLife: "12 months from production date"
  };

  // FAQ specific to 220ml
  const faqs = [
    {
      question: "What is the 220ml cup best used for?",
      answer: "The 220ml Edible cup is our standard size, perfect for regular coffee, tea, cappuccino, latte, and most hot beverages. It's the most popular choice for cafes and coffee shops."
    },
    {
      question: "How long can I keep my drink in the 220ml cup?",
      answer: "The 220ml cup is designed to hold hot beverages (up to 85°C) for 40 minutes and cold beverages for several hours without leaking or becoming soggy."
    },
    {
      question: "What does the cup taste like?",
      answer: "The cup has a subtle, pleasant cookie-like taste that complements coffee and tea perfectly. It won't alter the flavor of your drink while you're drinking it."
    },
    {
      question: "Is the 220ml cup suitable for espresso machines?",
      answer: "Yes! The 220ml cup fits most standard espresso machine drip trays. However, for pure espresso shots, we recommend our 110ml size for the perfect fit."
    },
    {
      question: "What is the minimum order quantity for businesses?",
      answer: "For retail customers and wholesale, there's no minimum order."
    }
  ];

  // Calculate price per cup for display
  const pricePerCup = selectedPricing.cups === 'sample' ? 0 : (selectedPricing.price / selectedPricing.cups).toFixed(2);

  return (
    <div className="edible-cup-page">
      {/* Breadcrumb Navigation */}
      <nav className="breadcrumb-nav">
        <div className="container">
          <ol className="breadcrumb">
            <li><Link to="/">Home</Link></li>
            <ChevronRight size={14} />
            <li><Link to="/edible-cups">Edible Cups</Link></li>
            <ChevronRight size={14} />
            <li className="current">Edible CUP | 220 ml</li>
          </ol>
        </div>
      </nav>

      {/* Main Product Section */}
      <section className="product-main-section">
        <div className="container">
          <div className="product-layout">
            {/* Image Gallery */}
            {/* Image Gallery */}
            <div className="product-gallery">
              <div className="main-image-container" onClick={() => openLightbox(selectedImage)}>
                <span className="zoom-hint">
                  <ZoomIn size={20} />
                  Click to zoom
                </span>
                <img 
                  ref={productImageRef}
                  src={productImages[selectedImage].src} 
                  alt={productImages[selectedImage].alt}
                  className="main-product-image clickable"
                />
              </div>
              <div className="thumbnail-gallery">
                {productImages.map((img, index) => (
                  <button
                    key={img.id}
                    className={`thumbnail-btn ${selectedImage === index ? 'active' : ''}`}
                    onClick={() => setSelectedImage(index)}
                    onDoubleClick={() => openLightbox(index)}
                  >
                    <img src={img.src} alt={img.alt} />
                  </button>
                ))}
              </div>
              
              {/* Key Features - Under Image */}
              <div className="key-features">
                <h3>Key Features</h3>
                <ul>
                  {keyFeatures.map((feature, index) => (
                    <li key={index}>
                      <Leaf size={16} className="feature-icon" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Product Info */}
            <div className="product-info">
              <span className="product-sku">SKU: {product.sku}</span>
              <h1 className="product-title">{product.name}</h1>
              <p className="product-subtitle">{product.subtitle}</p>

              {/* Price Display - Carton Based */}
              <div className="carton-pricing">
                {selectedPricing.cups === 'sample' ? (
                  <div className="price-main">
                    <span className="price free">FREE</span>
                    <span className="price-label">Sample</span>
                  </div>
                ) : (
                  <>
                    {(() => {
                      const priceInfo = getPriceInfo(selectedPricing.price);
                      return (
                        <div className={`price-main ${priceInfo.hasDiscount ? 'has-discount' : ''}`}>
                          {priceInfo.hasDiscount && (
                            <>
                              <span className="discount-badge">-{priceInfo.discountPercentage}</span>
                              <span className="price-original">€{priceInfo.originalPrice.toFixed(2)}</span>
                            </>
                          )}
                          <span className={`price ${priceInfo.hasDiscount ? 'discounted' : ''}`}>
                            €{priceInfo.discountedPrice.toFixed(2)}
                          </span>
                          <span className="price-label">for {selectedPricing.cups} cups ({selectedPricing.cartons} {selectedPricing.cartons === 1 ? 'carton' : 'cartons'})</span>
                        </div>
                      );
                    })()}
                  </>
                )}
                <div className={`stock-status ${stockInfo.isSoldOut ? 'sold-out' : 'in-stock'}`}>
                  {stockInfo.isSoldOut ? (
                    <>
                      <AlertCircle size={20} />
                      {stockInfo.statusLabel}
                    </>
                  ) : (
                    <>
                      <Check size={20} />
                      {stockInfo.statusLabel}
                    </>
                  )}
                </div>
                {stockInfo.isInStock && (
                  <div className="delivery-time">
                    <Truck size={16} />
                    <span>Delivery: {stockInfo.deliveryTime}</span>
                  </div>
                )}
              </div>

              {/* Carton Info */}
              <div className="carton-info-box">
                <Package size={20} />
                <div>
                  <strong>Sold by Carton</strong>
                  <span>Each carton contains {product.cupsPerCarton} cups</span>
                </div>
              </div>

              {/* Size Info */}
              <div className="size-info-box">
                <Coffee size={20} />
                <div>
                  <strong>220 ml Standard Size</strong>
                  <span>Perfect for coffee, tea, cappuccino & latte</span>
                </div>
              </div>

              {/* Quantity Selector - Dropdown */}
              <div className="purchase-controls-carton">
                <div className="quantity-dropdown-container">
                  <label>Select Quantity:</label>
                  <div className="quantity-dropdown">
                    <button 
                      className="quantity-dropdown-trigger"
                      onClick={() => setIsQuantityDropdownOpen(!isQuantityDropdownOpen)}
                    >
                      <span>
                        {selectedPricing.cups === 'sample' ? (
                          <>
                            <Gift size={16} />
                            Sample - FREE
                          </>
                        ) : (
                          <>
                            {(() => {
                              const priceInfo = getPriceInfo(selectedPricing.price);
                              return (
                                <>
                                  {selectedPricing.cups} cups ({selectedPricing.cartons} {selectedPricing.cartons === 1 ? 'carton' : 'cartons'}) - 
                                  {priceInfo.hasDiscount && (
                                    <span className="dropdown-original-price">€{priceInfo.originalPrice.toFixed(2)}</span>
                                  )}
                                  <span className={priceInfo.hasDiscount ? 'dropdown-discounted-price' : ''}>
                                    €{priceInfo.discountedPrice.toFixed(2)}
                                  </span>
                                </>
                              );
                            })()}
                          </>
                        )}
                      </span>
                      <ChevronDown size={18} className={isQuantityDropdownOpen ? 'rotate' : ''} />
                    </button>
                    
                    {isQuantityDropdownOpen && (
                      <div className="quantity-dropdown-menu">
                        {pricingOptions.map((option) => (
                          <button
                            key={option.cups}
                            className={`quantity-option ${String(option.cups) === selectedQuantity ? 'active' : ''}`}
                            onClick={() => {
                              setSelectedQuantity(String(option.cups));
                              setIsQuantityDropdownOpen(false);
                            }}
                          >
                            <div className="option-main">
                              {option.cups === 'sample' ? (
                                <>
                                  <Gift size={16} />
                                  <span className="option-cups">Sample</span>
                                </>
                              ) : (
                                <>
                                  <span className="option-cups">{option.cups} cups</span>
                                  <span className="option-cartons">({option.cartons} {option.cartons === 1 ? 'carton' : 'cartons'})</span>
                                </>
                              )}
                            </div>
                            <div className="option-price">
                              {option.cups === 'sample' ? (
                                <span className="free-tag">FREE</span>
                              ) : (
                                <>
                                  {(() => {
                                    const optPriceInfo = getPriceInfo(option.price);
                                    return (
                                      <>
                                        {optPriceInfo.hasDiscount && (
                                          <span className="option-original-price">€{optPriceInfo.originalPrice.toFixed(2)}</span>
                                        )}
                                        <span className={optPriceInfo.hasDiscount ? 'option-discounted-price' : ''}>
                                          €{optPriceInfo.discountedPrice.toFixed(2)}
                                        </span>
                                      </>
                                    );
                                  })()}
                                </>
                              )}
                            </div>
                            {String(option.cups) === selectedQuantity && <Check size={16} className="check-icon" />}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <button 
                  className={`add-to-cart-btn ${isAddedToCart ? 'added' : ''} ${isAddingToCart ? 'loading' : ''} ${stockInfo.isSoldOut ? 'disabled sold-out-btn' : ''}`}
                  disabled={stockInfo.isSoldOut || isAddingToCart}
                  onClick={() => {
                    if (stockInfo.isSoldOut || isAddingToCart) return;
                    
                    if (selectedPricing.cups === 'sample') {
                      // For samples, redirect to contact
                      window.location.href = '/contact';
                      return;
                    }
                    
                    // Start loading animation
                    setIsAddingToCart(true);
                    
                    const cartItem = {
                      id: 'edible-cup-220',
                      name: 'Edible CUP | 220 ml',
                      variant: `${selectedPricing.cups} cups (${selectedPricing.cartons} ${selectedPricing.cartons === 1 ? 'carton' : 'cartons'})`,
                      price: selectedPricing.price,
                      cartons: selectedPricing.cartons,
                      cups: selectedPricing.cups,
                      quantity: 1,
                      image: productImages[0].src
                    };
                    
                    // Simulate brief loading, then add with animation
                    setTimeout(() => {
                      setIsAddingToCart(false);
                      addToCartWithAnimation(cartItem, productImageRef.current);
                      setIsAddedToCart(true);
                      
                      // Reset button after 2 seconds
                      setTimeout(() => {
                        setIsAddedToCart(false);
                      }, 2000);
                    }, 300);
                  }}
                >
                  {stockInfo.isSoldOut ? (
                    <>
                      <AlertCircle size={20} />
                      Sold Out
                    </>
                  ) : isAddingToCart ? (
                    <span className="btn-loading-text">Adding...</span>
                  ) : isAddedToCart ? (
                    <>
                      <Check size={20} />
                      Added to Cart!
                    </>
                  ) : (
                    <>
                      <ShoppingCart size={20} />
                      {selectedPricing.cups === 'sample' ? (
                        'Request Free Sample'
                      ) : (
                        <>
                          {(() => {
                            const btnPriceInfo = getPriceInfo(selectedPricing.price);
                            return (
                              <>
                                Add to Cart - 
                                {btnPriceInfo.hasDiscount && (
                                  <span className="btn-original-price">€{btnPriceInfo.originalPrice.toFixed(2)}</span>
                                )}
                                <span className={btnPriceInfo.hasDiscount ? 'btn-discounted-price' : ''}>
                                  €{btnPriceInfo.discountedPrice.toFixed(2)}
                                </span>
                              </>
                            );
                          })()}
                        </>
                      )}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tabbed Content Section */}
      <section className="product-tabs-section">
        <div className="container">
          <div className="tabs-navigation">
            <button 
              className={`tab-btn ${activeTab === 'description' ? 'active' : ''}`}
              onClick={() => setActiveTab('description')}
            >
              Description
            </button>
            <button 
              className={`tab-btn ${activeTab === 'details' ? 'active' : ''}`}
              onClick={() => setActiveTab('details')}
            >
              Product Details
            </button>
            <button 
              className={`tab-btn ${activeTab === 'faq' ? 'active' : ''}`}
              onClick={() => setActiveTab('faq')}
            >
              FAQ
            </button>
          </div>

          <div className="tab-content">
            {/* Description Tab */}
            {activeTab === 'description' && (
              <div className="tab-panel description-panel">
                <h2>Edible Cupffee CUP | 220 ml - The Standard Choice</h2>
                <p>
                  The 220ml Cuppffee cup is our flagship product, designed specifically for the perfect cup of coffee or tea. 
                  This standard-size cup is the most popular choice among cafes, restaurants, and event organizers 
                  who want to offer their customers a unique, sustainable drinking experience.
                </p>
                <p>
                  With a capacity of 220ml, this cup perfectly accommodates a regular coffee, cappuccino, latte, 
                  or tea. The carefully engineered dimensions ensure it fits under most espresso machine dispensers 
                  while providing ample space for milk-based drinks with foam.
                </p>
                <p>
                  Made from 100% natural ingredients including wheat flour, oat bran, and coconut oil, each cup 
                  maintains its structural integrity for over 40 minutes with hot beverages. After enjoying your 
                  drink, simply eat the cup as a delicious, cookie-like snack, leaving zero waste behind.
                </p>
                
                <div className="description-features">
                  <div className="desc-feature">
                    <Thermometer size={32} />
                    <h4>Heat Resistant to 85°C</h4>
                    <p>Perfect for hot coffee, tea, and espresso-based drinks served at optimal temperature.</p>
                  </div>
                  <div className="desc-feature">
                    <Droplet size={32} />
                    <h4>The cup remains crunchy for up to 40 minutes!</h4>
                    <p>Enjoy your drink without rushing. Our coating ensures no leaks for over 40 minutes.</p>
                  </div>
                  <div className="desc-feature">
                    <Coffee size={32} />
                    <h4>Taste Neutral</h4>
                    <p>Your coffee tastes exactly as intended. The cookie flavor only emerges when you bite in.</p>
                  </div>
                </div>
              </div>
            )}

            {/* Product Details Tab */}
            {activeTab === 'details' && (
              <div className="tab-panel details-panel">
                <div className="details-grid">
                  <div className="detail-section">
                    <h3><Package size={20} /> Dimensions</h3>
                    <table className="details-table">
                      <tbody>
                        <tr><td>Capacity</td><td>{productDetails.dimensions.capacity}</td></tr>
                        <tr><td>Height</td><td>{productDetails.dimensions.height}</td></tr>
                        <tr><td>Top Diameter</td><td>{productDetails.dimensions.topDiameter}</td></tr>
                        <tr><td>Bottom Diameter</td><td>{productDetails.dimensions.bottomDiameter}</td></tr>
                        <tr><td>Weight</td><td>{productDetails.dimensions.weight}</td></tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="detail-section">
                    <h3><Leaf size={20} /> Ingredients</h3>
                    <ul className="ingredients-list">
                      {productDetails.ingredients.map((ingredient, index) => (
                        <li key={index}>{ingredient}</li>
                      ))}
                    </ul>
                    <p className="allergen-warning">
                      <strong>Allergen Information:</strong> Contains wheat and gluten.
                    </p>
                  </div>

                  <div className="detail-section">
                    <h3><Award size={20} /> Nutritional Information (per cup)</h3>
                    <table className="details-table">
                      <tbody>
                        <tr><td>Energy</td><td>{productDetails.nutritionalInfo.calories}</td></tr>
                        <tr><td>Protein</td><td>{productDetails.nutritionalInfo.protein}</td></tr>
                        <tr><td>Carbohydrates</td><td>{productDetails.nutritionalInfo.carbohydrates}</td></tr>
                        <tr><td>Fat</td><td>{productDetails.nutritionalInfo.fat}</td></tr>
                        <tr><td>Sugars</td><td>{productDetails.nutritionalInfo.Sugars}</td></tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="detail-section">
                    <h3><Clock size={20} /> Storage & Shelf Life</h3>
                    <p>{productDetails.storage}</p>
                    <p><strong>Shelf Life:</strong> {productDetails.shelfLife}</p>
                  </div>

                  <div className="detail-section full-width">
                    <h3><Award size={20} /> Edible Cupffee cup Certifications</h3>
                    <div className="certifications-list">
                      {productDetails.certifications.map((cert, index) => (
                        <span key={index} className="cert-badge">{cert}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* FAQ Tab */}
            {activeTab === 'faq' && (
              <div className="tab-panel faq-panel">
                <h2>Frequently Asked Questions - 220ml Cup</h2>
                <div className="faq-list">
                  {faqs.map((faq, index) => (
                    <div 
                      key={index} 
                      className={`faq-item ${expandedFaq === index ? 'expanded' : ''}`}
                    >
                      <button 
                        className="faq-question"
                        onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
                      >
                        <span>{faq.question}</span>
                        {expandedFaq === index ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                      </button>
                      {expandedFaq === index && (
                        <div className="faq-answer">
                          <p>{faq.answer}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Related Products Section */}
      <RelatedProducts currentProductId="cup-220" category="edible-cups" />

      {/* Image Lightbox Modal */}
      {isLightboxOpen && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>
              <X size={28} />
            </button>
            
            <button className="lightbox-nav lightbox-prev" onClick={goToPrevImage}>
              <ChevronLeft size={36} />
            </button>
            
            <div className="lightbox-image-container">
              <img 
                src={productImages[lightboxImageIndex].src} 
                alt={productImages[lightboxImageIndex].alt}
                className="lightbox-image"
              />
            </div>
            
            <button className="lightbox-nav lightbox-next" onClick={goToNextImage}>
              <ChevronRight size={36} />
            </button>
            
            <div className="lightbox-thumbnails">
              {productImages.map((img, index) => (
                <button
                  key={img.id}
                  className={`lightbox-thumb ${lightboxImageIndex === index ? 'active' : ''}`}
                  onClick={() => setLightboxImageIndex(index)}
                >
                  <img src={img.src} alt={img.alt} />
                </button>
              ))}
            </div>
            
            <div className="lightbox-counter">
              {lightboxImageIndex + 1} / {productImages.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EdibleCup220;
